module.exports = __webpack_public_path__ + "img/lock-red.3d1a22c7.svg";